import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@curves/ui-base';

import PageSortAndTotalBox from '@Local/Components/OverviewList/PageSortAndTotalBox';
import { isEmpty } from '@Util/utils';
/**
 * 概覽清單上方的摘要列，用來顯示標題與可選的排序／總數資訊。
 *
 * 常見使用情境：列表上方有「標題 + 筆數 + 排序選單」的情況。
 *
 * @component
 *
 * @param {Object} props - 元件的參數
 * @param {string} [props.className] - 自訂樣式的 className，會套在最外層 Stack 上
 * @param {string} [props.title] - 顯示在左側的標題文字
 * @param {Object} [props.titleProps] - 傳給標題 Typography 的額外 props，例如 variant、className
 * @param {string} [props.titleProps.className] - 額外加在標題上的 className
 * @param {string} [props.titleProps.variant='h5'] - 標題字體大小，預設為 h5
 * @param {string} [props.alignItems='center'] - Stack 的 alignItems 設定，預設為 center
 * @param {string} [props.justifyContent] - Stack 的 justifyContent 設定
 * @param {React.ReactNode} [props.children] - 若有額外內容可放在標題與排序元件之間
 * @param {boolean} [props.showSortAndTotal] - 若有額外內容可放在標題與排序元件之間
 * @param {Object} [props.pageSortAndTotalProps] - 傳入 PageSortAndTotalBox 的 props
 * @param {Object} [props.rest] - 其他額外 props 會傳給最外層 Stack
 *
 * @returns {JSX.Element} OverviewListSummary 元件
 */
const OverviewListSummary = ({
    className,
    title,
    titleProps = {},
    alignItems = 'center',
    justifyContent,
    children,
    showSortAndTotal = false,
    pageSortAndTotalProps = {},
    ...rest
}) => {
    return (
        <Stack className={clsx('overview-list__toolbar', className)} alignItems={alignItems} justifyContent={justifyContent} {...rest}>
            {title && (
                <Typography {...titleProps} className={clsx('font-weight-bold', titleProps?.className || '')} variant={titleProps?.variant || 'h5'}>
                    {title}
                </Typography>
            )}
            {!isEmpty(pageSortAndTotalProps) && (
                <PageSortAndTotalBox {...pageSortAndTotalProps} className={clsx('ml-2', pageSortAndTotalProps?.className || '')} />
            )}
        </Stack>
    );
};
OverviewListSummary.propTypes = {
    className: PropTypes.string,
    alignItems: PropTypes.string,
    justifyContent: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.string,
    titleProps: PropTypes.shape({
        className: PropTypes.string,
        variant: PropTypes.string,
    }),
    showSortAndTotal: PropTypes.bool,
};
export default OverviewListSummary;
